import { newE2EPage } from '@stencil/core/testing';

describe('jackery-rating', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-rating></jackery-rating>');

    const element = await page.find('jackery-rating');
    expect(element).toHaveClass('hydrated');
  });
});
